import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3344506d&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3344506d&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3344506d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\mam\\home\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3344506d')) {
      api.createRecord('3344506d', component.options)
    } else {
      api.reload('3344506d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3344506d&scoped=true", function () {
      api.rerender('3344506d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/register/verifyPage/index.vue"
export default component.exports